import React, { useContext } from 'react'
import CarOverviewHeader from 'app/React/Components/CarOverview/CarOverviewHeader'
import CarOverviewList from 'app/React/Components/CarOverview/CarOverviewList'
import CarOverviewColors from 'app/React/Components/CarOverview/CarOverviewColors'
import classNames from 'classnames'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function CarOverview({ marginTop, name, image, list, colorsTitle, onChange = () => {} }) {
  const {
    order,
    setOrder,
    setCurrentDealerColorTotalCount
  } = useContext(ConfiguratorContext)

  const dealerColors = order.configuration?.dealer_colors ?? []

  const calculateTotalCount = (colorsArray) => {
    if (colorsArray === undefined || colorsArray.length === 0) {
      return 0
    }

    return colorsArray.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.value
    }, 0)
  }

  const updateColorValue = (colorId, count) => {
    const newDealerColors = [...dealerColors]
    const index = newDealerColors.findIndex(c => c.id === colorId)

    if (index === -1) {
      return
    }

    // Update current color count
    newDealerColors[index].value = count
    order.configuration.dealer_colors = newDealerColors
    setOrder({ ...order })
    onChange(newDealerColors)

    // Update totalCount
    const newTotalCount = calculateTotalCount(newDealerColors)
    setCurrentDealerColorTotalCount(newTotalCount)
  }

  return (
    <div
      className={classNames('car-overview', {
        'car-overview--margin-top': marginTop
      })}
    >
      <CarOverviewHeader name={name} image={image}/>
      <CarOverviewList list={list}/>
      <CarOverviewColors colorsTitle={colorsTitle} updateColorValue={updateColorValue}/>
    </div>
  )
}
